module.exports = __webpack_public_path__ + "img/classic_1.d3c8b582.jpg";